const collectionData = [
  {
    id: 101,
    title: "Mens Tshirt",
    image: "/images/Men's_T_shirt.png",
    price: 899,
    description: "Premium cotton gym t-shirt designed for comfort and performance."
  },
  {
    id: 102,
    title: "Trackpants",
    image: "/images/Trackpants.png",
    price: 1299,
    description: "Flexible trackpants perfect for workouts and daily wear."
  },
  {
    id: 103,
    title: "Stringer",
    image: "/images/Stringer.png",
    price: 799,
    description: "Lightweight gym stringer with breathable fabric."
  },
  {
    id: 104,
    title: "Shorts",
    image: "/images/Shorts.png",
    price: 699,
    description: "Training shorts built for intense workouts."
  },
  {
    id: 105,
    title: "Summer Jacket",
    image: "/images/Summer_jacket.png",
    price: 1499,
    description: "Stylish lightweight summer jacket."
  },
  {
    id: 106,
    title: "Accessories",
    image: "/images/Accessories.png",
    price: 499,
    description: "Premium fitness accessories for every athlete."
  },
  {
    id: 107,
    title: "Women",
    image: "/images/Women.png",
    price: 999,
    description: "Women's activewear collection built for performance."
  }
];

export default collectionData;